module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lote-info"
  }, [_c('div', {
    staticClass: "lote-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.imagem
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lote-detalhes"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Comitente")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lote.comitente.pessoa.nome))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Descrição")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lote.descricao))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LANCE INICIAL")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorInicial)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("INCREMENTO")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorIncremento)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MÍNIMO")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorMinimo)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("META")]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorMeta)))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0146c3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-comitente/components/LoteInfo.vue
// module id = 1699
// module chunks = 17